import {
  jb_info_box_css_default
} from "./chunk.NOJ7BMXE.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.534YP5ZJ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-info-box/jb-info-box.ts
var JbInfoBox = class extends Initiable(Spaceable(i)) {
  constructor() {
    super(...arguments);
    this.isInText = false;
  }
  _getContentSpacingProperties() {
    return { grid: true, type: "text", colsMdUp: 8 };
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "info-box"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <div
        class="${e({
      "in-text": !!this.isInText,
      ...this.background ? { [`bg-${this.background}`]: true } : {},
      isbordered: !this.background
    })}"
      >
        ${this.headline ? b`<jb-heading variant="heading-lg">${this.headline}</jb-heading>` : A}
        <jb-richtext @jb-link:clicked=${this._tracking}>${o(this.content)}</jb-richtext>
        ${this.button ? b`<jb-button-secondary
                .link=${this.button.link}
                @jb-link:clicked=${this._tracking}
                >${this.buttonText}</jb-button-secondary
              >` : A}
      </div>
    `;
  }
};
JbInfoBox.styles = [reset_css_default, jb_info_box_css_default];
__decorateClass([
  n()
], JbInfoBox.prototype, "background", 2);
__decorateClass([
  n({ type: Object })
], JbInfoBox.prototype, "button", 2);
__decorateClass([
  n()
], JbInfoBox.prototype, "buttonText", 2);
__decorateClass([
  n()
], JbInfoBox.prototype, "content", 2);
__decorateClass([
  n({ reflect: true })
], JbInfoBox.prototype, "headline", 2);
__decorateClass([
  n({ type: Boolean })
], JbInfoBox.prototype, "isInText", 2);
JbInfoBox = __decorateClass([
  customElement("jb-info-box")
], JbInfoBox);

export {
  JbInfoBox
};
